var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "flex flex_gap" },
            [
              _c("DateSelect", { ref: "date" }),
              _vm._v(" "),
              _c("LoadingButton", {
                attrs: {
                  title: "Показать отчет",
                  type: "button",
                  loading: _vm.loading,
                  color: _vm.$constants.SUCCESS_COLOR,
                  onClick: () => _vm.showReport(),
                  className: "btn btn-outline-success",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading || _vm.records
        ? [
            _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("pulse-loader", {
                    staticClass: "text-center",
                    attrs: {
                      loading: _vm.loading,
                      color: _vm.$constants.LOADING_COLOR,
                    },
                  }),
                  _vm._v(" "),
                  _vm.records
                    ? _c(
                        "table",
                        { staticClass: "table table-sm table-hover mt-0" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(
                                _vm.$platformConstants.nonCashResources,
                                function (source, id) {
                                  return [
                                    source.useCards
                                      ? _vm._l(
                                          _vm.cards,
                                          function (card, cardId) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm._v(_vm._s(source.title)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(card.id) +
                                                    ") " +
                                                    _vm._s(card.number)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "RUB " +
                                                    _vm._s(
                                                      (
                                                        Math.round(
                                                          (_vm.records[id]
                                                            ?.expect?.[cardId]
                                                            ?.total_price ??
                                                            0) * 100
                                                        ) / 100
                                                      ).toLocaleString("ru-RU")
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.records[id]?.expect?.[
                                                        cardId
                                                      ]?.total_orders ?? 0
                                                    ) +
                                                    ")\n                "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("strong", [
                                                  _vm._v(
                                                    "RUB " +
                                                      _vm._s(
                                                        (
                                                          Math.round(
                                                            (_vm.records[id]
                                                              ?.closed?.[cardId]
                                                              ?.total_price ??
                                                              0) * 100
                                                          ) / 100
                                                        ).toLocaleString(
                                                          "ru-RU"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("td"),
                                            ])
                                          }
                                        )
                                      : [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "2" } },
                                              [_vm._v(_vm._s(source.title))]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                "RUB " +
                                                  _vm._s(
                                                    (
                                                      Math.round(
                                                        (_vm.records[id]?.expect
                                                          ?.total_price ?? 0) *
                                                          100
                                                      ) / 100
                                                    ).toLocaleString("ru-RU")
                                                  ) +
                                                  "\n                  (" +
                                                  _vm._s(
                                                    _vm.records[id]?.expect
                                                      ?.total_orders ?? 0
                                                  ) +
                                                  ")\n                "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _c("strong", [
                                                _vm._v(
                                                  "$ " +
                                                    _vm._s(
                                                      Math.round(
                                                        (_vm.records[id]?.closed
                                                          ?.total_currency_sum ??
                                                          0) * 100
                                                      ) / 100
                                                    )
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("td"),
                                          ]),
                                        ],
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("p", [_vm._v("Новый расход")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newExpenses.affect_saldo,
                          expression: "newExpenses.affect_saldo",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.newExpenses.affect_saldo)
                          ? _vm._i(_vm.newExpenses.affect_saldo, null) > -1
                          : _vm.newExpenses.affect_saldo,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.newExpenses.affect_saldo,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.newExpenses,
                                  "affect_saldo",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.newExpenses,
                                  "affect_saldo",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.newExpenses, "affect_saldo", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(
                      "\n            расход влияет на прибыль\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex_gap" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Дата")]),
                      _vm._v(" "),
                      _c("DateSelect", { ref: "expensesDate" }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Источник")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newExpenses.card_id,
                            expression: "newExpenses.card_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newExpenses,
                              "card_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "0" } }, [
                          _vm._v("Выберите карту"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.cards, function (card, cardId) {
                          return _c("option", { domProps: { value: cardId } }, [
                            _vm._v(_vm._s(card.number)),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Сумма")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newExpenses.sum,
                          expression: "newExpenses.sum",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number" },
                      domProps: { value: _vm.newExpenses.sum },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.newExpenses, "sum", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Комментарий"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newExpenses.comment,
                          expression: "newExpenses.comment",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.newExpenses.comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.newExpenses,
                            "comment",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "align-self-end" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Сохранить",
                          type: "button",
                          loading: _vm.btnLoading,
                          color: _vm.$constants.SUCCESS_COLOR,
                          onClick: () => _vm.addExpenses(),
                          className: "btn btn-outline-success",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.expenses.length
                  ? _c(
                      "table",
                      { staticClass: "table table-sm table-hover mt-0" },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _vm._l(_vm.expenses, function (e, i) {
                          return _c("tr", [
                            _c("td", [
                              _vm._v(_vm._s(i + 1) + " (" + _vm._s(e.id) + ")"),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  e.affect_saldo ? "" : "Не влияет на прибыль"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.cards[e.card_id]?.number ?? e.card_id
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(e.comment))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(e.sum))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("LoadingButton", {
                                  attrs: {
                                    title:
                                      '<i class="icon-fa icon-fa-remove"/>',
                                    type: "button",
                                    loading: _vm.removeBtnLoading,
                                    color: _vm.$constants.SUCCESS_COLOR,
                                    onClick: () => _vm.removeRecord(),
                                    className: "btn btn-default",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("p", [_vm._v("Новая инкассация")]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex_gap" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Дата")]),
                      _vm._v(" "),
                      _c("DateSelect", { ref: "incomeDate" }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Источник")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newIncome.source_id,
                            expression: "newIncome.source_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newIncome,
                              "source_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "0" } }, [
                          _vm._v("Выберите источник"),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.$platformConstants.nonCashResources,
                          function (source, id) {
                            return !source.useCards
                              ? _c("option", { domProps: { value: id } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(source.title) +
                                      "\n              "
                                  ),
                                ])
                              : _vm._e()
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Сумма")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newIncome.sum,
                          expression: "newIncome.sum",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number" },
                      domProps: { value: _vm.newIncome.sum },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.newIncome, "sum", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Кошелек получателя"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newIncome.wallet,
                          expression: "newIncome.wallet",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.newIncome.wallet },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.newIncome, "wallet", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "align-self-end" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Сохранить",
                          type: "button",
                          loading: _vm.btnLoading,
                          color: _vm.$constants.SUCCESS_COLOR,
                          onClick: () => _vm.addIncome(),
                          className: "btn btn-outline-success",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.withdrawal.length
                  ? _c(
                      "table",
                      { staticClass: "table table-sm table-hover mt-0" },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _vm._l(_vm.withdrawal, function (r, i) {
                          return _c("tr", [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.$platformConstants.nonCashResources[
                                    r.source_id
                                  ]?.title ?? r.source_id
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(r.sum))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.printSendReceive(r.data))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("LoadingButton", {
                                  attrs: {
                                    title:
                                      '<i class="icon-fa icon-fa-remove"/>',
                                    type: "button",
                                    loading: _vm.removeBtnLoading,
                                    color: _vm.$constants.SUCCESS_COLOR,
                                    onClick: () => _vm.removeRecord(),
                                    className: "btn btn-default",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [_c("NonCashExpenses")], 1),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Балансы счетов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Источник")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ожидается перевод")]),
        _vm._v(" "),
        _c("th", [_vm._v("Баланс")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Расходы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("карта")]),
        _vm._v(" "),
        _c("th", [_vm._v("комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("сумма")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Инкассации с обменников")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Источник")]),
        _vm._v(" "),
        _c("th", [_vm._v("сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("получатель")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("История расходов по картам")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }